import { render } from "./Fieldset.vue?vue&type=template&id=4453be1f"
import script from "./Fieldset.vue?vue&type=script&lang=js"
export * from "./Fieldset.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__